// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EmailErrorCode;
(function (EmailErrorCode) {
    EmailErrorCode[EmailErrorCode["NUMBER_0"] = 0] = "NUMBER_0";
    EmailErrorCode[EmailErrorCode["NUMBER_1"] = 1] = "NUMBER_1";
    EmailErrorCode[EmailErrorCode["NUMBER_2"] = 2] = "NUMBER_2";
    EmailErrorCode[EmailErrorCode["NUMBER_3"] = 3] = "NUMBER_3";
    EmailErrorCode[EmailErrorCode["NUMBER_100"] = 100] = "NUMBER_100";
})(EmailErrorCode || (EmailErrorCode = {}));
//# sourceMappingURL=emailErrorCode.js.map